var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClassType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 56,
    height: 56,
    rx: 24,
    fill: "#F1E9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17 20.0003C17 17.0548 19.3878 14.667 22.3333 14.667H35.6667C38.6122 14.667 41 17.0548 41 20.0003V36.0003C41 38.9458 38.6122 41.3337 35.6667 41.3337H22.3333C19.3878 41.3337 17 38.9458 17 36.0003V20.0003Z",
    fill: "#1C0054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 19C26.975 19 25.3334 20.6416 25.3334 22.6667V25.3333V28C25.3334 28.5523 25.7811 29 26.3334 29C26.8857 29 27.3334 28.5523 27.3334 28V26.3333H30.6667V28C30.6667 28.5523 31.1144 29 31.6667 29C32.219 29 32.6667 28.5523 32.6667 28V25.3333V22.6667C32.6667 20.6416 31.0251 19 29 19ZM30.6667 24.3333V22.6667C30.6667 21.7462 29.9205 21 29 21C28.0796 21 27.3334 21.7462 27.3334 22.6667V24.3333H30.6667Z",
    fill: "#1C0054"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6666 32C22.6666 31.4477 23.1143 31 23.6666 31L34.3333 31C34.8856 31 35.3333 31.4477 35.3333 32C35.3333 32.5523 34.8856 33 34.3333 33H23.6666C23.1143 33 22.6666 32.5523 22.6666 32Z",
    fill: "#1C0054"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6666 36C22.6666 35.4477 23.1143 35 23.6666 35H29C29.5522 35 30 35.4477 30 36C30 36.5523 29.5522 37 29 37H23.6666C23.1143 37 22.6666 36.5523 22.6666 36Z",
    fill: "#1C0054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassType);
export default __webpack_public_path__ + "static/media/class-type.3a1d02314f117425ef00504ce2a6d966.svg";
export { ForwardRef as ReactComponent };